import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { Button } from "../../../components/Component";
import { useFormContext } from "react-hook-form";
import FormInput from "../../form-components/InputComponent";
import PhoneNumberInput from "../../form-components/PhoneNumberInput";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import sites from "../../../api/master/sites";
import Swal from "sweetalert2";

interface SelectOptions {
  label: string;
  value: string;
}

const ContactInformation: React.FC = (props: any) => {
  const {
    handleSubmit,
    formState: { errors },
  }: any = useFormContext();

  const [workingSites, setWorkingSites] = useState<SelectOptions[]>([]);

  const fetchWorkingSites = async () => {
    try {
      const { data, status, message } = await sites.fetchSites();
      if (status) {
        setWorkingSites(
          data.map((item: any) => ({
            label: item.name,
            value: item.siteID?.toString(),
          }))
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.message, "error");
    }
  };

  useEffect(() => {
    fetchWorkingSites();
  }, []);

  const submitForm = (data: any) => {
    console.log("Contact Information Data:", data);
    props.next();
  };

  return (
    <form className="content clearfix" onSubmit={handleSubmit(submitForm)}>
      <h5 className="mb-3">Contact Information</h5>
      <Row className="gy-4">
        <Col md="6" lg="3">
          <FormInput
            name="contactPerson"
            label="Contact Person"
            required={true}
            type="text"
            maxLength={50}
            placeholder="Enter Contact Person"
            pattern={/^[A-Za-z\s]+$/}
            onInput={(e: any) => {
              e.target.value = e.target.value.replace(/[^A-Za-z\s]/g, "");
            }}
          />
        </Col>

        <Col md="6" lg="3">
          <FormMultiSelect
            name="siteAccessibility"
            label="Site Accessibility"
            required={true}
            options={workingSites}
            placeholder="Select Site Accessibility"
          />
        </Col>

        <Col md="6" lg="3">
          <FormInput
            name="email"
            label="Email"
            required={true}
            type="email"
            placeholder="Enter Email"
            pattern={/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/}
          />
        </Col>

        <Col md="6" lg="3">
          <PhoneNumberInput name="phoneNumber" required={true} />
        </Col>
      </Row>

      <div className="actions clearfix">
        <ul>
          <li>
            <Button color="primary" type="submit">
              Next
            </Button>
          </li>
          <li>
            <Button color="primary" onClick={props.prev}>
              Previous
            </Button>
          </li>
        </ul>
      </div>
    </form>
  );
};

export default ContactInformation;
